import { motion, useMotionValue } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useNotifications } from '../context/NotificationProvider';
import { NotificationType } from '../types/notification-types';
import { csi } from '../lib/utils';
import {
  StyledNotification,
  NotificationTitle,
  NotificationMessage,
  NotificationLink,
  NotificationCloseButton
} from '../styles/NotificationStyles';

function Notification({
  id,
  type,
  message,
  title,
  duration,
  link,
  linkText,
}: NotificationType) {
  const { removeNotification } = useNotifications();
  const [isHovering, setIsHovering] = useState(false);
  const opacity = useMotionValue(0);
  const y = useMotionValue(-100);

  useEffect(() => {
    let timeoutId: any;
    if (!isHovering) {
      timeoutId = setTimeout(() => removeNotification(id), duration);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isHovering, removeNotification, duration]);

  const handleLinkClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    csi.openURLInDefaultBrowser(link);
  };

  return (
    <StyledNotification
      key={id}
      onClick={() => removeNotification(id)}
      onHoverStart={() => setIsHovering(true)}
      onHoverEnd={() => setIsHovering(false)}
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      style={{ opacity, y }}
      type={type}
      hover={isHovering}
    >
      <NotificationCloseButton onClick={() => removeNotification(id)}>
        X
      </NotificationCloseButton>
      <NotificationTitle>{title}</NotificationTitle>
      {message !== undefined && message.length !== 0 && (
        <NotificationMessage>{message}</NotificationMessage>
      )}
      {link && linkText && (
        <NotificationLink onClick={handleLinkClick}>
          {linkText}
        </NotificationLink>
      )}
    </StyledNotification>
  );
}

export default Notification;
